// Roles del panel (backend/roles.py): el operador lleva el día a día de las reservas (también la liquidación de la
// devolución, que devuelve o libera la fianza); ajustes, usuarios, finanzas, exportaciones, devoluciones de cobros y
// borrados son del administrador. El backend lo impone.
export const ROLES = [["admin", "Administrador"], ["operador", "Operador"]];

export function esAdmin(user) {
  if (!user) return false;
  return (user.role || "admin") === "admin";
}

export function nombreRol(rol) {
  const fila = ROLES.find(([r]) => r === rol);
  return fila ? fila[1] : "Operador";
}
